import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress,
  Grid,
  IconButton
} from "@mui/material";
import { BsEyeFill, BsPencilSquare, BsTrashFill, BsXCircle } from "react-icons/bs";
import Swal from "sweetalert2";
import usericon from './user.png'
import './main.css'
export default function MoreInfo({ css = {}, icons = {}, icon = 'thumbnail', skip = [], type, group = [], data = {}, onClick, keys, onClose = () => { } }) {
  const cols = type === "user" ? [2, 10] : [4, 8];
  const [copys, setCopy] = React.useState("")
  const handleClick = onClick || (() => { });

  const avatar = (type, data, keys) => {

    const imageSrc = data[keys[0]];
    if (type === "user") {
      return (
        <Box
          component="img"
          src={usericon}
          loading="lazy"
          alt=""
          sx={{
            width: '100%',
            objectFit: "cover",
            borderRadius: 2,

          }}
        />
      );
    }
    return (
      <Box
        component="img"
        src={imageSrc}
        loading="lazy"
        alt=""
        sx={{
          width: '100%',
          objectFit: "cover",
          borderRadius: 2,
        }}
      />
    );
  };

  function isImageUrl(url) {
    return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(url);
  }

  return (
    <Grid container>
      <Grid size={{ sm: 12, md: 12 }} sx={{ position: 'relative' }}>

        <Card className="shadow rounded position-relative" sx={{ p: 2, mb: 1, mt: 2 }}>
          <BsXCircle style={{ position: 'absolute', right: 10, top: 24, fontSize: 20, color: '#d95f18ff' }} onClick={() => onClose()} />
          <Box display={'flex'} gap={2}>
            <Box
              component="img"
              src={data[icon]}
              loading="lazy"
              alt=""
              sx={{
                width: 150,
                objectFit: "cover",
                borderRadius: 2,
              }}
            />
            <Box>
              {group.map((key, i) => {
                return <>
                  {/* <Grid container>
                    <Grid>
                      <Typography fontSize={13} sx={{ textTransform: 'capitalize' }}>{key.replaceAll('_', ' ')}</Typography>
                    </Grid>
                    <Grid>
                      <Typography color={`${i == 0 ? '#d99918' : ''}`} fontWeight={600} fontSize={(i == 0 ? 13 : 11)} sx={{ mb: 0.4 }}>{data[key]}</Typography>
                    </Grid>
                  </Grid> */}
                  <Box display={'flex'} gap={2}>
                    <Typography fontSize={13} sx={{ minWidth: 100, textTransform: 'capitalize' }}>{key.replaceAll('_', ' ')}</Typography>
                    <Typography color={`${i == 0 ? '#d99918' : ''}`} fontWeight={600} fontSize={(i == 0 ? 13 : 11)} sx={{ mb: 0.4, ...css[key] }}>{data[key]}</Typography>
                    {icons[key] && <Typography onClick={(e) => {
                      window.navigator.clipboard.writeText(data[key])
                        .then(() => setCopy("Copied"))
                        .catch(err => console.error("Failed to copy: ", err));
                    }}>{icons[key]} <Box fontSize={10}>{copys}</Box></Typography>}
                  </Box>
                </>
              })}
            </Box>
          </Box>

        </Card>
        <Card className="shadow rounded" sx={{ p: 2 }}>
          {Object.keys(data).map((key) => {
            if (group.includes(key)) return
            if (skip.includes(key)) return
            if (Array.isArray(data[key])) return
            if (typeof data[key] === 'object') return

            const value = data[key];

            // Check if value is an image URL or local image path
            const isImage = typeof value === "string" && /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(value);

            return <>
              <Grid container spacing={1} sx={{ mb: 1 }}>
                <Grid size={{ xs: 12, md: 3 }}>
                  <Typography fontSize={13} sx={{ textTransform: 'capitalize' }}>{key.replaceAll('_', ' ')}</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 9 }}>
                  {isImage ? (
                    <Box
                      component="img"
                      src={value}
                      alt={key}
                      loading="lazy"
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "4px",
                        objectFit: "cover",
                        border: "1px solid #ddd",
                      }}
                    />
                  ) : (
                    <Typography fontWeight={600} fontSize={(12)}> {value} </Typography>
                  )}
                </Grid>
              </Grid>
              {/* <Box display={'flex'} gap={2} sx={{ mb: 1 }}>
                <Typography fontSize={13} sx={{ textTransform: 'capitalize' }}>{key.replaceAll('_', ' ')}</Typography>
                <Typography fontWeight={600} fontSize={(12)}>{data[key]}</Typography>
              </Box> */}
            </>
          })}
        </Card>
      </Grid>
    </Grid>
  );
}
